import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * request for getting order list
 * @param {Object} filters filters object containing filter parameters
  * @param {Number} filters.page page number
  * @param {Number} filters.size data size each page
  * @param {String} filters.sort filed;ASC|DESC
  * @param {Number} filters.dateFrom date long
  * @param {Number} filters.dateTo date long
  * @param {Number} filters.shipperId shipper id
  * @param {String} filters.shipperName shipper name
  * @param {Number} filters.transporterId transporter id
  * @param {String} filters.transporterName transporter name
  * @param {Number} filters.originId origin id
  * @param {String} filters.origin origin name
  * @param {Number} filters.destinationId destination id
  * @param {String} filters.destination destionation name
  * @param {Array} filters.status shipping status strings
  * @param {Number} filters.shipmentNo order number
  * @param {Number} filters.selfOrder 1 (Own) : 0 (all)
 */
const fetchOrders = async function (filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: filters.size
    }
    if (filters.sort) data.sort = filters.sort
    if (filters.dateFrom) data.dateFrom = filters.dateFrom
    if (filters.dateTo) data.dateTo = filters.dateTo
    if (filters.shipperId) data.shipperId = filters.shipperId
    if (filters.shipperName) data.shipperName = filters.shipperName
    if (filters.transporterId) data.transporterId = filters.transporterId
    if (filters.transporterName) data.transporterName = filters.transporterName
    if (filters.originId) data.originId = filters.originId
    if (filters.origin) data.origin = filters.origin
    if (filters.destinationId) data.destinationId = filters.destinationId
    if (filters.destination) data.destination = filters.destination
    if (filters.status.length) data.status = filters.status
    if (filters.shipmentNo) data.shipmentNo = filters.shipmentNo
    if (filters.selfOrder) data.selfOrder = filters.selfOrder
    if (filters.calculationStatus && filters.calculationStatus.length) data.calculationStatus = filters.calculationStatus
    if (filters.groupId) data.groupId = filters.groupId

    console.log('TCL: fetchOrders -> data', urls.orderList + `?${querystring.stringify(data)}`)
    let res = await axios.get(urls.orderList + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch order's detail
 * @param {Number} id order id
 */
const fetchOrderDetail = async function (id) {
  try {
    let res = await axios.get(urls.orderDetail + '/' + id)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch shipment group's detail
 * @param {Number} id shipment id
 */
const fetchShipmentGroupDetail = async function (id) {
  try {
    let res = await axios.get(urls.shipmentGroupDetail + '/' + id)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch documents for an order
 * @param {Number} orderId order Id
 * @param {String} type Document Type
 */
const fetchOrderDocuments = async function (orderId, type) {
  try {
    let res = await axios.get(urls.orderDocuments(orderId, type))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update order document completion status
 * @param {Number} orderId order id
 * @param {Number} isComplete completion status in binary (0/1)
 */
const updateDocumentCompletionStatus = async function (orderId, isComplete) {
  try {
    let data = {
      shipmentId: orderId,
      complete: isComplete,
    }
    let res = await axios.put(urls.orderDocumentCompletion, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch order status updates history
 * @param {Number} id order id
 */
const fetchOrderStatusHistory = async function (id) {
  try {
    console.log('TCL: urls.orderStatusHistory(id)', urls.orderStatusHistory(id))
    let res = await axios.get(urls.orderStatusHistory(id))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch order summary
 * @param {Number} todayDate requested date summary
 */
const fetchOrderSummary = async function (todayDate) {
  try {
    let data = {
      todayDate: new Date(todayDate).setHours(0, 0, 0, 0)
    }
    let res = await axios.get(urls.orderSummary + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transport list to be assigned to an order
 * @param {Number} search search value
 * @param {Number} orderId order id for transport to be assigned to
 * @param {Number} transporterId transporter client id for transport to be assigned to
 * @param {Number} page available transport list page number, starts from 0
 * @param {Number} size transport list size per page
 * @param {String} sort sort transport by, format: field;ASC|DESC
 */
const fetchAvailableTransports = async function (search, transporterId, orderId, page, size, sort) {
  try {
    let filters = {
      page, size, sort, search
    }
    let res = await axios.get(urls.availableTransports(orderId, transporterId) + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transporter's available drivers
 * @param {Number} search search value
 * @param {Number} orderId order id for driver to be assigned to
 * @param {Number} transporterId transporter id for the requested drivers
 * @param {Number} page available driver list page number, starts from 0
 * @param {Number} size driver list size per page
 * @param {String} sort sort driver by, format: field;ASC|DESC
 */
const fetchAvailableDrivers = async function (search, shipmentGroupId, transporterId, page, size, sort) {
  try {
    let filters = {
      page, size, sort, search
    }
    let res = await axios.get(urls.availableDrivers(shipmentGroupId, transporterId) + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * assign transport and driver to an Order
 * @param {Number} shipmentId shipment/order Id
 * @param {Number} transportId transport Id
 * @param {Number} driverId driver's Id
 * @param {String} driverName driver's Name
 * @param {String} driverPhone driver's phone number
 */
const assignTransport = async function (shipmentGroupId, transportId, driverId, driverName, driverPhone, isReassign) {
  try {
    let data = {
      shipmentGroupId,
      transportId,
      driverId,
      driverName,
      driverPhone,
    }
    let res
    if (isReassign) {
      res = await axios.post(urls.reassignTransport, data)
      return res.data
    } else {
      res = await axios.post(urls.assignTransport, data)
      return res.data
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * update unit quantity in an order
 * @param {Number} orderId order id
 * @param {Object} form unit detail form
 * @param {String} form.unit unit of measurement of choice
 * @param {Array} form.unitDetail array of object with delivery note number and qty ammount
 * @param {Boolean} isEdit if is editing
 */
const updateQuantityInfo = async function (shipmentGroupId, form, isEdit) {
  try {
    let data = {
      ...form,
      shipmentGroupId,
    }
    let res
    if (isEdit) {
      res = await axios.put(urls.orderQuantity, data)
    } else {
      res = await axios.post(urls.orderQuantity, data)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch quantity info
 * @param {Number} orderId order id
 */
const fetchQuantityInfo = async function (orderId) {
  try {
    let data = {
      shipmentGroupId: orderId
    }
    console.log('fetchQuantityInfo url ', urls.orderQuantity + '?' + querystring.stringify(data))
    let res = await axios.get(urls.orderQuantity + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Fetch calculated quantity
 * @param {Number} orderId order id
 */
const fetchCalculatedQuantity = async function (orderId) {
  try {
    let res = await axios.get(urls.orderCalculatedQuantity + '?shipmentGroupId=' + orderId)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch unit option for quantity input from contract
 * @param {Number} orderId order / shipment Id
 */
const fetchUnitOptionsFromContract = async function (orderId) {
  try {
    let res = await axios.get(urls.orderContractUnitOptions + '?' + querystring.stringify({ shipmentId: orderId }))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const fetchShipmentGroup = async function (filters) {
  try {
    let data = {
      page: filters.page - 1,
      size: filters.size
    }
    if (filters.sort) data.sort = filters.sort
    if (filters.dateFrom) data.dateFrom = filters.dateFrom
    if (filters.dateTo) data.dateTo = filters.dateTo
    if (filters.shipperId) data.shipperId = filters.shipperId
    if (filters.shipperName) data.shipperName = filters.shipperName
    if (filters.transporterId) data.transporterId = filters.transporterId
    if (filters.transporterName) data.transporterName = filters.transporterName
    if (filters.originId) data.originId = filters.originId
    if (filters.origin) data.origin = filters.origin
    if (filters.destinationId) data.destinationId = filters.destinationId
    if (filters.destination) data.destination = filters.destination
    if (filters.status.length) data.status = filters.status
    if (filters.shipmentNo) data.shipmentNo = filters.shipmentNo
    if (filters.selfOrder) data.selfOrder = filters.selfOrder
    if (filters.transportId) data.transportId = filters.transportId
    if (!isNaN(parseInt(filters.completePod))) data.completePod = filters.completePod
    if (filters.calculationStatus && filters.calculationStatus.length) data.calculationStatus = filters.calculationStatus

    console.log('TCL: fetchShipmentGroup -> data', urls.shipmentGroupList + `?${querystring.stringify(data)}`)
    let res = await axios.get(urls.shipmentGroupList + `?${querystring.stringify(data)}`)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * get orderlist available page sizes for table
 */
const orderListPageSizes = async function () {
  try {
    const res = await axios.get(urls.orderListPageSizes)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}
export {
  fetchOrders,
  fetchOrderDetail,
  fetchOrderStatusHistory,
  fetchOrderSummary,
  fetchAvailableTransports,
  fetchAvailableDrivers,
  assignTransport,
  updateQuantityInfo,
  fetchOrderDocuments,
  fetchCalculatedQuantity,
  fetchQuantityInfo,
  fetchUnitOptionsFromContract,
  updateDocumentCompletionStatus,
  orderListPageSizes,
  fetchShipmentGroupDetail,
  fetchShipmentGroup
}
